<template>
  <div>
    <q-select
      ref="autocomplete"
      :label="`${label}...   Powered by Google`"
      v-model="value"
      use-input
      :loading="loading"
      :options="places"
      input-debounce="100"
      option-label="description"
      option-value="place_id"
      @filter="getPredictedPlaces"
      @keydown.enter="selectFirstPlace()"
      @input="getPlaceData"
      :filled="filled"
    ></q-select>
  </div>
</template>

<script>
  export default {
    props: {
      filled: {
        default: false,
        type: Boolean,
      },
      label: {
        default: "Starting Location",
        type: String,
      },
      selectedPlace: {
        default: null,
      },
    },
    data: () => ({
      autocompleteServiceAPI: null,
      placesAPI: null,

      value: "",
      places: [],
      loading: false,
    }),
    watch: {
      selectedPlace: function () {
        if (this.selectedPlace) {
          // console.log(JSON.parse(this.selectedPlace));
          this.manuallySetPlace(this.selectedPlace);
        }
      },
    },
    mounted() {
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }

      this.$gmapApiPromiseLazy().then(() => {
        this.autocompleteServiceAPI =
          new google.maps.places.AutocompleteService();
        this.placesAPI = new google.maps.places.PlacesService(
          document.createElement("div")
        );
      });
    },
    methods: {
      getPredictedPlaces(val, update) {
        this.loading = true;
        update(() => {
          if (val === "") {
            this.places = [];
          } else {
            this.autocompleteServiceAPI.getPlacePredictions(
              { input: val, componentRestrictions: { country: "nz" } },
              (res) => {
                this.places = res;
              }
            );
          }
          this.loading = false;
        });
      },
      selectFirstPlace() {
        this.value = this.places[0];
        this.$refs.autocomplete.blur();
      },
      getPlaceData() {
        this.placesAPI.getDetails({ placeId: this.value.place_id }, (res) => {
          this.$emit("placeSelected", res);
        });
      },
      manuallySetPlace(place) {
        let placeObj = {
          description: place,
          palceId: 0,
        };
        this.value = placeObj;
        this.places = [placeObj];
      },
    },
  };
</script>
